import * as React from 'react';
import { Box } from '../../CommonUI/Layout';
import { Label } from '../../CommonUI';
import { StyleSheet, css } from 'aphrodite';

interface ParagraphProps extends React.HTMLProps<HTMLAnchorElement> {
    caption?: string;
    text: string;
    boldText?: boolean;
    pl?: number;
    mt?: number;
    captionMb?: number;
}

export const Paragraph: React.SFC<ParagraphProps> = (props) => {
    const { text, caption, boldText, pl, mt, captionMb } = props;
    return (
        <Box pl={pl} mt={mt}>
            {caption && <Label label={caption} mb={captionMb} />}
            <div className={css(styles.text, boldText && styles.boldText)}>{text}</div>
        </Box>
    );
};

Paragraph.defaultProps = {
    boldText: false,
    pl: 20,
    mt: 24,
    captionMb: 24,
};

const styles = StyleSheet.create({
    text: {
        lineHeight: '1.43',
        letterSpacing: 'normal',
        color: '#292929',
    },
    boldText: {
        fontWeight: 'bold',
    }
});



// WEBPACK FOOTER //
// ./src/CommonUI/Control/Paragraph.tsx